import { coinManager } from "@/phaser/core/game/CoinManager";
import { getShopItemById } from "@phaser/core/shop/shopCatalog";
import { shopInventoryManager } from "@phaser/core/shop/ShopInventoryManager";
import type { PurchaseResult } from "@phaser/core/shop/shopTypes";

class ShopPurchaseService {
  async purchase(itemId: string): Promise<PurchaseResult> {
    const item = getShopItemById(itemId);

    if (!item) {
      return {
        success: false,
        reason: "ITEM_NOT_FOUND",
      };
    }

    if (shopInventoryManager.isOwned(item.id)) {
      return {
        success: false,
        reason: "ALREADY_OWNED",
      };
    }

    const balance = coinManager.getBalance();

    if (balance < item.price) {
      return {
        success: false,
        reason: "NOT_ENOUGH_COINS",
      };
    }

    await coinManager.spendCoins(item.price);
    await shopInventoryManager.addOwnedItem(item.id);

    return {
      success: true,
      itemId: item.id,
      balance: coinManager.getBalance(),
    };
  }
}

export const shopPurchaseService = new ShopPurchaseService();
